// extracted by mini-css-extract-plugin
module.exports = {"fukidashi":"fukidashi_fukidashi__3EHsI","fukidashi2":"fukidashi_fukidashi2__2MKp5"};